import { keyframes } from "@emotion/react";
import { primary } from "../themes/theme";

export const textFieldStyle = {
  width: "100%",
  "& .MuiInputLabel-root": {
    color: "lightgrey",
    fontFamily: "ubuntu",
    "&.Mui-focused": {
      color: primary[700],
      transform: "translate(14px, -11px) scale(1)",
    },
  },
  "& .MuiOutlinedInput-root": {
    fontWeight: "bold",
    fontFamily: "ubuntu",
    fontSize: "18px",
    "& fieldset": {
      borderColor: primary[100],
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      border: `2px solid ${primary[700]}`,
    },
    "&.Mui-focused fieldset": {
      border: `2px solid ${primary[700]}`,
    },
  },
};

export const buttonHoverAnimation = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.02);
  }
`;
